"use client";
import {
  MotionImage,
  MotionImageProps,
  MotionStack,
  MotionStackProps,
  MotionVariantProps,
} from "./motion-components";
import { StaticImageData } from "next/image";
import { SxProps, Theme } from "@mui/material";
import { FixedLengthArray } from "type-fest";
import { deepmerge } from "@mui/utils";

export interface ArrowBannerBackgroundProps
  extends Omit<MotionStackProps, "children"> {
  images: FixedLengthArray<string | StaticImageData, 3>;
  CommonImageProps?: Omit<MotionImageProps, "src" | "alt">;
}

const ArrowBannerBackground = (props: ArrowBannerBackgroundProps) => {
  const { images, CommonImageProps, ...restStack } = props;
  const [img1, img2, img3] = images;
  return (
    <MotionStack {...deepmerge(defaultWrapperProps, restStack)}>
      <MotionImage
        src={img1}
        alt={"image-1"}
        {...deepmerge(
          defaultImageProps,
          deepmerge(
            {
              sx: {
                mr: imagePosition,
              },
            },
            CommonImageProps,
          ),
        )}
      />
      <MotionImage
        src={img2}
        alt={"image-2"}
        {...deepmerge(defaultImageProps, CommonImageProps)}
      />
      <MotionImage
        src={img3}
        alt={"image-3"}
        {...deepmerge(
          defaultImageProps,
          deepmerge(
            {
              sx: {
                ml: imagePosition,
              },
            },
            CommonImageProps,
          ),
        )}
      />
    </MotionStack>
  );
};

export default ArrowBannerBackground;

const imagePosition = {
  xs: "-60px",
  md: "-90px",
  lg: "-115px",
  xxl_wide: "-155px",
} as const;

const imageSx: SxProps<Theme> = {
  width: { xs: 342, md: 486, lg: 618, xxl_wide: 826 },
  minWidth: { xs: 342, md: 486, lg: 618, xxl_wide: 826 },
  minHeight: 1,
  height: { xs: 336, md: 478, lg: 608, xxl_wide: 812 },
  clipPath: "polygon(80% 0%, 100% 50%, 80% 100%, 0% 100%, 20% 50%, 0 0)",
  objectFit: "cover",
};

const staggerBanner: MotionVariantProps = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.2,
      staggerDirection: -1,
    },
  },
};
const staggerBannerChildren: MotionVariantProps = {
  initial: {
    x: "-150%",
    opacity: 0,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
    },
  },
};

const defaultWrapperProps: MotionStackProps = {
  direction: "row",
  width: 1,
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  position: "absolute",
  overflow: "hidden",
  top: 0,
  left: 0,
  zIndex: -1,
  variants: staggerBanner,
  initial: "initial",
  animate: "animate",
};

const defaultImageProps: Omit<MotionImageProps, "src" | "alt"> = {
  width: 618,
  height: 608,
  sx: imageSx,
  variants: staggerBannerChildren,
};
